// Tiny createElement re-export so .ts files (router) can build elements without JSX.
import React from 'react';
export const createElement: (...a: any[]) => any = (React as any).createElement;
